import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { urlWithLocale } from '../../utils/locale';

export class AnalyticsTrackers extends React.PureComponent {
  componentDidMount() {
    const { user, orderStatusTracking } = this.props;
    const hasDataLayer = Boolean(window.dataLayer);

    if (hasDataLayer) {
      this.trackFacebookUser(user);
    }

    if (orderStatusTracking && hasDataLayer) {
      this.trackOrderStatus(user, orderStatusTracking);
    }
  }

  trackContentForImpactRadius(impactRadiusData, orderId) {
    window.dataLayer.push({
      impactRadiusPromoCode: impactRadiusData.promoCode,
      impactRadiusCurrency: impactRadiusData.currency,
      impactRadiusOrderId: orderId,
      impactRadiusItem0: impactRadiusData.item[0],
      impactRadiusItem1: impactRadiusData.item[1],
      impactRadiusItem2: impactRadiusData.item[2],
      impactRadiusItem3: impactRadiusData.item[3],
      event: 'impactRadiusContentSet',
    });
  }

  trackFacebookPurchase(user, purchaseData) {
    this.trackFacebookUser(user);
    window.dataLayer.push({
      facebookPurchaseData: purchaseData,
      event: 'facebookPurchaseDataSet',
    });
  }

  trackShopBack(shopBackData) {
    window.dataLayer.push({
      shopBackAmount: shopBackData.amount,
      shopBackCustomerType: shopBackData.customerType,
      shopBackDeliveredAt: shopBackData.deliveredAt,
      shopBackOrderId: shopBackData.orderId,
      shopBackRestaurantId: shopBackData.restaurantId,
      event: 'shopBackDataSet',
    });
  }

  trackFacebookUser(user) {
    if (window.fbqActivated === true) {
      return;
    }

    window.fbqActivated = true;

    const formatValue = (value) => value && value.toLowerCase().replace(/ /g, '');

    let dataLayerAdditions = {
      event: 'facebookUserSet',
    };

    if (user) {
      dataLayerAdditions = {
        ...dataLayerAdditions,
        facebookEmail: formatValue(user.email),
        facebookPhone: user.phone && user.phone.replace(/[^0-9.]/g, ''),
        facebookFirstName: formatValue(user.firstName),
        facebookLastName: formatValue(user.lastName),
        event: 'facebookUserSet',
      };
    }

    window.dataLayer.push(dataLayerAdditions);
  }

  trackOrderStatus(user, orderStatusTracking) {
    if (orderStatusTracking.facebookPurchaseTracking) {
      this.trackFacebookPurchase(user, orderStatusTracking.facebookPurchaseTracking);
    }

    if (orderStatusTracking.shopBack) {
      this.trackShopBack(orderStatusTracking.shopBack);
    }

    const { orderId } = this.props;

    if (orderStatusTracking.impactRadius) {
      this.trackContentForImpactRadius(orderStatusTracking.impactRadius, orderId);
    }
  }

  render() {
    const { country, locale, guid } = this.props;
    return (
      <img
        height="1"
        src={urlWithLocale(country, `/anonymous_user_guid.gif?guid=${guid}`, locale)}
        style={{ position: 'absolute', left: '-9999px', top: '-9999px' }}
        width="1"
        alt=""
      />
    );
  }
}

AnalyticsTrackers.propTypes = {
  country: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  locale: PropTypes.string.isRequired,
  guid: PropTypes.string.isRequired,
  // eslint-disable-next-line react/no-unused-prop-types
  query: PropTypes.object, // eslint-disable-line react/forbid-prop-types
  user: PropTypes.object, // eslint-disable-line react/forbid-prop-types
  orderStatusTracking: PropTypes.object, // eslint-disable-line react/forbid-prop-types
  orderId: PropTypes.string,
};

AnalyticsTrackers.defaultProps = {
  query: {},
  user: null,
  orderId: null,
  orderStatusTracking: null,
};

export default connect(({ request, user }) => ({
  country: request.country,
  locale: request.locale,
  guid: request.rooGuid,
  query: request.currentQuery,
  user: {
    email: user.email,
    phone: user.phone,
    firstName: user.firstName,
    lastName: user.lastName,
  },
}))(AnalyticsTrackers);
